export default "__VITE_ASSET__EVCch$o3__"